const scrollMiddleware = (routes) => (router, dependencies) => (toState, fromState, done) => {
  window.scrollTo(0, 0)
  done()
}

export default scrollMiddleware